(function () {
  function initCustomerVoice(root) {
    if (!root || root.dataset.lpcvInitialized === 'true') return;
    root.dataset.lpcvInitialized = 'true';

    var buttons = root.querySelectorAll('[data-lpcv-filter]');
    var cards = root.querySelectorAll('[data-lpcv-review-card]');
    var search = root.querySelector('[data-lpcv-search]');
    var empty = root.querySelector('[data-lpcv-empty]');
    var active = 'all';

    function updateReviews() {
      var query = search && search.value ? search.value.trim().toLowerCase() : '';
      var visible = 0;

      cards.forEach(function (card) {
        var topic = card.getAttribute('data-topic') || '';
        var media = card.getAttribute('data-media') || '';
        var filterMatch = active === 'all' || topic === active || media === active;
        var haystack = ((card.textContent || '') + ' ' + (card.getAttribute('data-search') || '')).toLowerCase();
        var searchMatch = !query || haystack.indexOf(query) !== -1;
        var show = filterMatch && searchMatch;

        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.classList.toggle('lpcv-empty--visible', visible === 0);
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        active = button.getAttribute('data-lpcv-filter') || 'all';
        buttons.forEach(function (btn) {
          btn.classList.toggle('is-active', btn === button);
        });
        updateReviews();
      });
    });

    if (search) search.addEventListener('input', updateReviews);
    updateReviews();
  }

  function initAll() {
    document.querySelectorAll('[data-lpcv-root]').forEach(initCustomerVoice);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-lpcv-root]').forEach(initCustomerVoice);
  });
}());